/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState } from 'react'
import { useServiceContext } from '../../../root'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { ModalImport } from '../../../components/modals/ModalImport'

interface PageMenuProps {
  onAddProperty: () => void
  onExportStart?: () => void
  onExportEnd?: () => void
}

const PageMenu: React.FC<PageMenuProps> = ({ onAddProperty, onExportStart, onExportEnd }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const { toast } = context.service
  const [showImportModal, setShowImportModal] = useState(false)

  const handleExport = async () => {
    try {
      // Start loading
      if (onExportStart) {
        onExportStart()
      }

      // Export all properties using PROPERTIES entity constant
      await context.api.settings.exportSettingsData('PROPERTIES', undefined, undefined, translate)
    } catch (error) {
      toast.error(translate('SETTINGS_IMPORT_FAIL'))
    } finally {
      // End loading
      if (onExportEnd) {
        onExportEnd()
      }
    }
  }

  const settings = {
    menuId: 'page',
    items: [
      {
        value: 'METADATA_ADD_METADATA_COMMAND',
        action: () => {
          onAddProperty()
        }
      },
      {
        value: 'METADATA_IMPORT',
        action: () => {
          setShowImportModal(true)
        }
      },
      {
        value: 'METADATA_EXPORT',
        action: handleExport
      }
    ]
  }

  return (
    <div className="dropdown">
      <ActionsMenuBig {...settings} />
      {showImportModal && (
        <ModalImport
          importType={context.constant.system.settings.entities.PROPERTIES}
          show={showImportModal}
          onClose={() => {
            setShowImportModal(false)
          }}
        />
      )}
    </div>
  )
}

export default PageMenu
